import * as React from 'react';
import { Battery, getFloat } from 'js-electrical-engineering-equations';
import { useCallback, useState } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from '@material-ui/core';

const fieldsDefaults = {
  batteryCapacityInAmpHours: '1',
  currentDrawInAmps: '1',
  efficiency: '.8',
};

export function BatteryRuntimeComponent(): JSX.Element {
  const [fields, setFields] = useState(fieldsDefaults);
  const [battery, setBattery] = useState(new Battery());

  const clear = useCallback(() => {
    setFields(fieldsDefaults);
  }, [setFields]);

  const onChange = useCallback(
    (event) => {
      const field = event.target.name;
      const value = event.target.value;
      setFields({ ...fields, [field]: value });
      console.log({ ...fields, [field]: value });
    },
    [fields, setFields],
  );

  const calculate = useCallback(
    (e) => {
      e.preventDefault();
      const newBattery = new Battery();
      newBattery.setBatteryCapacityInAmpHours(parseFloat(fields.batteryCapacityInAmpHours));
      newBattery.setCurrentDraw(parseFloat(fields.currentDrawInAmps));
      newBattery.efficiency = fields.efficiency;
      newBattery.calculateRuntime();
      setBattery(newBattery);
    },
    [fields, setBattery],
  );

  return (
    <form onSubmit={calculate}>
      <div>
        <Card>
          <CardContent>
            <div>
              <p>
                Calculate the runtime on a battery. This equation does not take into account the
                diminished runtime effect of high current applications.
              </p>
              <p>The efficiency of the system is set to 80% by default.</p>
              <TextField
                label="Battery capacity in amp hours"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                name="batteryCapacityInAmpHours"
                margin="normal"
                onChange={onChange}
                value={fields.batteryCapacityInAmpHours}
              />
              <TextField
                label="Current draw in amps"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                name="currentDrawInAmps"
                margin="normal"
                onChange={onChange}
                value={fields.currentDrawInAmps}
              />
              <TextField
                label="Efficiency of system"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                name="efficiency"
                margin="normal"
                onChange={onChange}
                value={fields.efficiency}
              />
            </div>
          </CardContent>
          <CardActions>
            <Button type="button" tabIndex="6" onClick={clear}>
              Clear
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={{ marginLeft: 'auto' }}
            >
              Calculate
            </Button>
          </CardActions>
        </Card>
        <Card>
          <CardContent>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">Battery capacity in amp hours</TableCell>
                  <TableCell align="left">{battery.getBatteryCapacityInAmpHours()}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Battery capacity in coulombs</TableCell>
                  <TableCell align="left">{battery.getBatteryCapacityInCoulombs()}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Battery run time in min</TableCell>
                  <TableCell align="left">{battery.getRunTimeInMin()}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Battery run time in hours</TableCell>
                  <TableCell align="left">{battery.getRunTimeInHours()}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Battery run time in days</TableCell>
                  <TableCell align="left">
                    {getFloat(battery.getRunTimeInHours() / 24, 4)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}
